import api from "@/lib/axios";

export const getBrand = async () => {
  const { data } = await api.get("/tenant");
  return data.data;
};

// Menü dilleri: platformun kataloğu + bu kiracının açtıkları + taban dil kodu. Panelde sabit dil
// listesi yok; Ayarlar'daki seçim de ürün/kategori formlarındaki çeviri alanları da buradan besleniyor.
export const getMenuLanguages = async () => {
  const { data } = await api.get("/tenant/languages");
  return data.data;
};

export const updateBrand = async (payload) => {
  const { data } = await api.patch("/tenant", payload);
  return data.data;
};

const postFile = async (path, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post(path, formData);
  return data.data;
};

// Upload the logo and set Tenant.logoUrl.
export const uploadLogo = (file) => postFile("/tenant/logo", file);

// Upload a derived image (favicon/apple-touch) — returns the URL, no tenant write.
export const uploadTenantImage = async (file) =>
  (await postFile("/tenant/upload", file)).url;

// The square mark small formats prefer (branch picker card, favicon, home-screen icon). Clearing
// it is API-only (DELETE /tenant/mark) — the panel deliberately has no remove button.
export const uploadMark = (file) => postFile("/tenant/mark", file);

// The menu's loading screen image. The R2 KEY is always `.png` so the menu can build the URL from
// the slug alone; the stored content-type is whatever was sent (the API accepts jpeg/png/webp/svg).
// The panel always sends PNG because the crop pipeline encodes one.
export const uploadLoadingImage = (file) =>
  postFile("/tenant/loading-image", file);

// Şube bağlantısı için kullanıcının kendi simgesi. Hiçbir DB kolonuna yazmıyor — dönen adres
// Branch.links[].icon içine giriyor ve şube kaydedilince oraya gömülüyor. Kullanılmayan dosyaları
// gece süpürmesi topluyor (api jobs/pruneLinkIcons), o yüzden burada "eskisini sil" yok.
export const uploadLinkIcon = async (file) =>
  (await postFile("/tenant/link-icon", file)).url;

// Gün sonu rapor mailinin fazladan alıcıları. Kullanıcı hesapları bu listede DEĞİL: marka sahibi
// ve şube müdürleri raporu kendiliğinden alıyor, kapsamları sunucuda kendi şube atamalarından
// çözülüyor.
